export enum ContentCreationCreativity {
	mad,
	promethean,
	creative,
	predictable
}